import { Add } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const styles = {
    title: { fontWeight: 400 },
};

const AppointmentRequestHeader = ({ onNewAppointment }) => {
    const navigate = useNavigate();

    const handleNewAppointment = () => {
        if (onNewAppointment) {
            onNewAppointment();
        } else {
            navigate('/appointment/new-appointment');
        }
    };

    return (
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
            <Grid item xs={12} sm="auto">
                <Typography variant="h4" sx={styles.title}>
                    Appointment Requests
                </Typography>
            </Grid>

            <Grid item xs={12} sm="auto">
                <Button fullWidth variant="contained" color="secondary" size="large" startIcon={<Add />} onClick={handleNewAppointment}>
                    NEW APPOINTMENT
                </Button>
            </Grid>
        </Grid>
    );
};

export default AppointmentRequestHeader;
